/**
 * installTelemetry — the two facts needed to count PWA installs (job #783):
 *   - `app_launch` once per page load, carrying whether it ran standalone
 *     (display-mode: standalone, or iOS navigator.standalone) and the surface.
 *   - `pwa_installed` when the browser fires `appinstalled`.
 * Privacy-light: no UA string, no identifiers beyond the player_events
 * session/learner attribution every event already carries. Counting
 * standalone launches by distinct learner is the install signal for iOS,
 * which never fires appinstalled.
 */
import { detectFromBrowser } from './installPlatform'

export type InstallLog = (type: string, payload?: Record<string, unknown>) => void

export function startInstallTelemetry(log: InstallLog, target: Window = window): () => void {
  try {
    const p = detectFromBrowser()
    log('app_launch', { standalone: p.isStandalone, surface: p.surface })
  } catch { /* telemetry never blocks UX */ }
  const onInstalled = () => {
    try { log('pwa_installed', { surface: detectFromBrowser().surface }) } catch { /* silent */ }
  }
  target.addEventListener('appinstalled', onInstalled)
  return () => target.removeEventListener('appinstalled', onInstalled)
}
